import React, { Component } from "react";

import { NavLink } from "react-router-dom";

import {
  Header,
  HeaderContent,
  HeaderToggler,
  Collapse,
  Nav,
  NavItem,
  Icon,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  LinkList,
} from "design-react-kit";

import { LESSON_ACTIVITY_TYPES, REVISOR_CONTEXTS, ROUTES } from "../../const";

export class NHAdmin extends Component {
  state = {
    collapsed: true,
  };

  manageEvtByLink = (link) => {
    this.setState({ collapsed: true });
  };

  //--- ---

  render() {
    const isOpen = !this.state.collapsed;

    return (
      <>
        <Header small theme="" type="navbar">
          <HeaderContent expand="lg" megamenu>
            <HeaderToggler
              aria-controls="nav1"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={() => this.setState({ collapsed: isOpen })}
            >
              <Icon icon="it-burger" />
            </HeaderToggler>
            <Collapse isOpen={isOpen} navbar header onOverlayClick={() => this.setState({ collapsed: true })}>
              <div className="menu-wrapper mnemo-dark">
                <Nav navbar tag="ul" vertical={false}>
                  <NavItem key={`menu-item-close`} tag="li" onClick={() => this.setState({ collapsed: isOpen })}>
                    <div className="mnemo-close-li">
                      CHIUDI <Icon icon="it-close-circle" padding={false} />
                    </div>
                  </NavItem>

                  <NavItem tag="li">
                    <UncontrolledDropdown nav tag="div">
                      <UncontrolledDropdown>
                        <DropdownToggle aria-haspopup caret color="secondary" nav>
                          Amministrazione
                        </DropdownToggle>
                        <DropdownMenu flip ag="div" className="dropdown-menu-show-fix mnemo-dark">
                          <LinkList tag="div">
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={ROUTES.CONTACT_REQUEST} ag="a">
                                Lista adesioni
                              </NavLink>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={ROUTES.PROMOTIONAL_MANAGER} ag="a">
                                Promozioni
                              </NavLink>
                            </NavItem>

                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={ROUTES.SITECONFIG_MANAGER} ag="a">
                                Configurazione
                              </NavLink>
                            </NavItem>
                          </LinkList>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </UncontrolledDropdown>
                  </NavItem>

                  <NavItem tag="li">
                    <UncontrolledDropdown nav tag="div">
                      <UncontrolledDropdown>
                        <DropdownToggle aria-haspopup caret color="secondary" nav>
                          BANDI
                        </DropdownToggle>
                        <DropdownMenu flip ag="div" className="dropdown-menu-show-fix mnemo-dark">
                          <LinkList tag="div">
                            <NavItem tag="li">
                              <b className="px-4 text-white">PERCORSI ABILITANTI</b>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={ROUTES.ANALYSIS_SUMMARY_REPORT} ag="a">
                                Report Sintetico
                              </NavLink>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={ROUTES.ANALYSIS_USEREVALUATIONS_REPORT} ag="a">
                                Consultazione Graduatorie
                              </NavLink>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={ROUTES.BANDO_EVALUATION_LOG} ag="a">
                                Consultazione Scorrimenti
                              </NavLink>
                            </NavItem>
                            <hr />
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={ROUTES.IMPORT_FROM_CONTINGENTE} ag="a">
                                Importazione Contingente
                              </NavLink>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={ROUTES.IMPORT_FROM_RECOGNITION} ag="a">
                                Importazione Riconoscimenti
                              </NavLink>
                            </NavItem>
                            <hr />
                            <NavItem tag="li">
                              <b className="px-4 text-white">TFA INDIRE</b>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={ROUTES.IMPORT_FROM_GOMP} ag="a">
                                Importazione TFA INDIRE
                              </NavLink>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={ROUTES.IMPORT_FROM_GOMP_CLASSIC} ag="a">
                                Importazione TFA Classico
                              </NavLink>
                            </NavItem>
                            <hr />
                            <NavItem tag="li">
                              <b className="px-4 text-white">TFA INDIRE UNITELMA</b>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={ROUTES.ANALYSIS_USEREVALUATIONS_REPORT_INDIRE} ag="a">
                                Consultazione Graduatorie
                              </NavLink>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={ROUTES.BANDO_EVALUATION_LOG} ag="a">
                                Consultazione Scorrimenti
                              </NavLink>
                            </NavItem>
                            <hr />
                          </LinkList>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </UncontrolledDropdown>
                  </NavItem>

                  <NavItem tag="li">
                    <UncontrolledDropdown nav tag="div">
                      <UncontrolledDropdown>
                        <DropdownToggle aria-haspopup caret color="secondary" nav>
                          Area Revisore
                        </DropdownToggle>

                        <DropdownMenu flip ag="div" className="dropdown-menu-show-fix mnemo-dark">
                          <LinkList tag="div">
                            <NavItem tag="li">
                              <b className="px-4 text-white">Revisioni Prove scritte</b>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={ROUTES.VIEWER_UDA} ag="a">
                                Consultazione Prova scritta
                              </NavLink>
                            </NavItem>
                            <hr />
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={`${ROUTES.PENDING_REVISION_ADMIN_30CFU}/${REVISOR_CONTEXTS.ART13}`} ag="a">
                                Revisioni non idonee Ex art.13
                              </NavLink>
                            </NavItem>

                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={`${ROUTES.PENDING_REVISION_ADMIN_30CFU}/${REVISOR_CONTEXTS.ABILITAZIONE30}`} ag="a">
                                Revisioni non idonee Abilitazione 30CFU
                              </NavLink>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={`${ROUTES.PENDING_REVISION_ADMIN_30CFU}/${REVISOR_CONTEXTS.ABILITAZIONE60}`} ag="a">
                                Revisioni non idonee Abilitazioni 60CFU
                              </NavLink>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={`${ROUTES.PENDING_REVISION_ADMIN_30CFU}/${REVISOR_CONTEXTS.TFAINDIRE}`} ag="a">
                                Revisioni non idonee TFA Indire
                              </NavLink>
                            </NavItem>

                            <hr />
                            <NavItem tag="li">
                              <b className="px-4 text-white">Tirocinio diretto - Corsi Abilitanti</b>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink
                                className="list-item"
                                to={`${ROUTES.CURRENT_REVISION_LESSON_ACTIVITY}/${REVISOR_CONTEXTS.TIROCINIODIRETTO}/${LESSON_ACTIVITY_TYPES.ABILITAZIONI}`}
                                ag="a"
                              >
                                Revisioni Correnti
                              </NavLink>
                            </NavItem>

                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink
                                className="list-item"
                                to={`${ROUTES.HISTORY_REVISION_LESSON_ACTIVITY}/${REVISOR_CONTEXTS.TIROCINIODIRETTO}/${LESSON_ACTIVITY_TYPES.ABILITAZIONI}/revisioned`}
                                ag="a"
                              >
                                Storico Revisioni
                              </NavLink>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink
                                className="list-item"
                                to={`${ROUTES.PENDING_REVISION_LESSON_ACTIVITY}/${REVISOR_CONTEXTS.TIROCINIODIRETTO}/${LESSON_ACTIVITY_TYPES.ABILITAZIONI}/revisionPending`}
                                ag="a"
                              >
                                Storico Revisioni Non Idonee
                              </NavLink>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={ROUTES.LESSON_ACTIVITY_ARCHIVE} ag="a">
                                Archivio
                              </NavLink>
                            </NavItem>
                            <hr />
                            <NavItem tag="li">
                              <b className="px-4 text-white">Tirocinio diretto - TFA Indire</b>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink
                                className="list-item"
                                to={`${ROUTES.CURRENT_REVISION_LESSON_ACTIVITY}/${REVISOR_CONTEXTS.TIROCINIODIRETTO}/${LESSON_ACTIVITY_TYPES.TFA_INDIRE}`}
                                ag="a"
                              >
                                Revisioni Correnti
                              </NavLink>
                            </NavItem>

                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink
                                className="list-item"
                                to={`${ROUTES.HISTORY_REVISION_LESSON_ACTIVITY}/${REVISOR_CONTEXTS.TIROCINIODIRETTO}/${LESSON_ACTIVITY_TYPES.TFA_INDIRE}/revisioned`}
                                ag="a"
                              >
                                Storico Revisioni
                              </NavLink>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink
                                className="list-item"
                                to={`${ROUTES.PENDING_REVISION_LESSON_ACTIVITY}/${REVISOR_CONTEXTS.TIROCINIODIRETTO}/${LESSON_ACTIVITY_TYPES.TFA_INDIRE}/revisionPending`}
                                ag="a"
                              >
                                Storico Revisioni Non Idonee
                              </NavLink>
                            </NavItem>
                          </LinkList>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </UncontrolledDropdown>
                  </NavItem>

                  <NavItem tag="li">
                    <UncontrolledDropdown nav tag="div">
                      <UncontrolledDropdown>
                        <DropdownToggle aria-haspopup caret color="secondary" nav>
                          Utenti
                        </DropdownToggle>
                        <DropdownMenu flip ag="div" className="dropdown-menu-show-fix mnemo-dark">
                          <LinkList tag="div">
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={`${ROUTES.USER_LIST}/admin`} tag="a">
                                Amministratori
                              </NavLink>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={`${ROUTES.USER_LIST}/student`} tag="a">
                                Studenti
                              </NavLink>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={`${ROUTES.USER_LIST}/segreteria`} tag="a">
                                Segreteria
                              </NavLink>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={`${ROUTES.USER_LIST}/editor`} tag="a">
                                Editor
                              </NavLink>
                            </NavItem>

                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={`${ROUTES.USER_LIST}/revisor`} tag="a">
                                Revisori
                              </NavLink>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={`${ROUTES.USER_LIST}/steward`} tag="a">
                                Steward
                              </NavLink>
                            </NavItem>

                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={`${ROUTES.USER_SYNC_IN}`} tag="a">
                                Sincronizza BD.BE
                              </NavLink>
                            </NavItem>
                          </LinkList>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </UncontrolledDropdown>
                  </NavItem>

                  <NavItem tag="li">
                    <UncontrolledDropdown nav tag="div">
                      <UncontrolledDropdown>
                        <DropdownToggle aria-haspopup caret color="secondary" nav>
                          Corsi
                        </DropdownToggle>
                        <DropdownMenu flip ag="div" className="dropdown-menu-show-fix mnemo-dark">
                          <LinkList tag="div">
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={ROUTES.COURSE_MANAGER} ag="a">
                                Elenco Corsi
                              </NavLink>
                            </NavItem>

                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={ROUTES.COURSE_TYPE_MANAGER} ag="a">
                                Tipo Corsi
                              </NavLink>
                            </NavItem>

                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={ROUTES.COURSE_REPOQUIZ_MANAGER} ag="a">
                                Deposito delle Domande
                              </NavLink>
                            </NavItem>
                          </LinkList>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </UncontrolledDropdown>
                  </NavItem>

                  <NavItem tag="li">
                    <UncontrolledDropdown nav tag="div">
                      <UncontrolledDropdown>
                        <DropdownToggle aria-haspopup caret color="secondary" nav>
                          Lezioni Sincrone
                        </DropdownToggle>
                        <DropdownMenu flip ag="div" className="dropdown-menu-show-fix mnemo-dark">
                          <LinkList tag="div">
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink to={ROUTES.LESSON_LIVE_CLASS} className="list-item">
                                Gestione Aule
                              </NavLink>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink to={ROUTES.LESSON_ONSITE_CLASS_BADGE} className="list-item">
                                Badge Accesso Aula
                              </NavLink>
                            </NavItem>

                            <hr />

                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={ROUTES.LESSON_LIVE_SCHEDULE} ag="a">
                                Lezioni Online
                              </NavLink>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={ROUTES.LESSON_ONSITE_SCHEDULE} ag="a">
                                Lezioni in Presenza
                              </NavLink>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={ROUTES.TRAINING_SCHEDULE} ag="a">
                                Tirocinio indiretto
                              </NavLink>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink to={ROUTES.LESSON_STUDENT_SCHEDULE} className="list-item">
                                Lezioni per studente
                              </NavLink>
                            </NavItem>

                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink to={ROUTES.LESSON_LIVE_CLASS_MATERIAL} className="list-item">
                                Materiale didattico
                              </NavLink>
                            </NavItem>

                            <hr />

                            <NavItem>
                              <NavLink to={ROUTES.LESSON_STUDENT_ANALYTICS} className="list-item">
                                Statistiche frequenza studente
                              </NavLink>
                            </NavItem>

                            <NavItem>
                              <NavLink to={ROUTES.LESSON_LIVE_PROCESS_ANALYTICS} className="list-item">
                                Analisi frequenza ex Art. 13
                              </NavLink>
                            </NavItem>

                            <NavItem>
                              <NavLink to={ROUTES.LESSON_PROCESS_ANALYTICS_TFA_INDIRE} className="list-item">
                                Analisi frequenza TFA INDIRE
                              </NavLink>
                            </NavItem>

                            <NavItem>
                              <NavLink to={ROUTES.LESSON_PROCESS_ANALYTICS_TFA_CLASSICO} className="list-item">
                                Analisi frequenza TFA CLASSICO
                              </NavLink>
                            </NavItem>

                            <NavItem>
                              <NavLink to={ROUTES.LESSON_LIVE_PROCESS_ANALYTICS_VC} className="list-item">
                                Analisi frequenza 30/60 e VC [Unicamillus e Reggio]
                              </NavLink>
                            </NavItem>

                            <NavItem>
                              <NavLink to={ROUTES.LESSON_LIVE_PROCESS_ANALYTICS_VC_SECIONTGROUP} className="list-item">
                                Analisi frequenza 30/60 e VC [Unitelma]
                              </NavLink>
                            </NavItem>

                            <hr />

                            <NavItem>
                              <NavLink to={ROUTES.LESSON_LIVE_ACCESS_ANOMALY} className="list-item">
                                Anomalie Accessi (lezioni online)
                              </NavLink>
                            </NavItem>

                            <NavItem>
                              <NavLink to={ROUTES.LESSON_TRAINING_ACCESS_ANOMALY} className="list-item">
                                Anomalie Accessi (tirocinio indiretto online)
                              </NavLink>
                            </NavItem>
                          </LinkList>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </UncontrolledDropdown>
                  </NavItem>

                  <NavItem tag="li">
                    <UncontrolledDropdown nav tag="div">
                      <UncontrolledDropdown>
                        <DropdownToggle aria-haspopup caret color="secondary" nav>
                          CMS
                        </DropdownToggle>
                        <DropdownMenu flip ag="div" className="dropdown-menu-show-fix mnemo-dark">
                          <LinkList tag="div">
                            <NavItem tag="li">
                              <b className="px-4 text-white">Newsletter</b>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={ROUTES.NEWSLETTER_SUBSCRIBERS} ag="a">
                                Iscritti
                              </NavLink>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={ROUTES.NEWSLETTER_EMAILS} ag="a">
                                Invio email
                              </NavLink>
                            </NavItem>
                            <hr />
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={ROUTES.BLOG_CATEGORY_MANAGER} ag="a">
                                Articoli
                              </NavLink>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={ROUTES.PAGE_MANAGER} ag="a">
                                Pagine
                              </NavLink>
                            </NavItem>

                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={ROUTES.SURVEY_MANAGER} ag="a">
                                Questionari
                              </NavLink>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={ROUTES.LIBRARY_CATEGORY_MANAGER} ag="a">
                                Biblioteca
                              </NavLink>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={ROUTES.QUALIFICATION_DATA_ANS_MANAGER} ag="a">
                                Gestione Dati ANS
                              </NavLink>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={ROUTES.ASSETS_AUDIO_CATEGORY_MANAGER} ag="a">
                                Assets Audio
                              </NavLink>
                            </NavItem>
                            <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                              <NavLink className="list-item" to={ROUTES.ACTIONS_OVER_DB} ag="a">
                                Azioni su DB
                              </NavLink>
                            </NavItem>
                          </LinkList>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </UncontrolledDropdown>
                  </NavItem>

                  <NavItem tag="li" onClick={this.props.logout}>
                    <NavLink className="nav-link" to="/" ag="a">
                      Esci
                    </NavLink>
                  </NavItem>
                </Nav>
              </div>
            </Collapse>
          </HeaderContent>
        </Header>
      </>
    );
  }
}
